import axios from "axios";
import Vue from "vue";
import AWS from "aws-sdk";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

let sessionId = window.name;
export default {
  state: () => ({
    passengers: {},
    allocationId: {},
    totalPrice: {},
    passengerPriceList: {},
    railBookingResponse: {},
    railBookingRequest: {},
    reservationStatus: {},
    issueTicketResponse: {},
    getReservationResponse: {},
    checkSeatSelectionPricesRequest: {},
    countDownActive: {},
    unlabeledCarTrainSearchMode: {},
    isCountDownDisplay: {},
    prefilledSeats: {},
    isPaymentDone: {},
    changeReservationRequest: {},
    changeReservationResponse: {},
    changeReservationPerformResponse: {},
    ticketChangePerformResponse: {},
    seferSearchInformation: {},
    selectedGidisTrip: {},
    selectedDonusTrip: {},
    endDate: {},
    endDate2: {},
    ticketChangeType: {},
    reservationSearchStatus: {},
    isTimeExpired: {},
    srmPassengers: {},
    searchModalRequest: {},
    isReservationSale: {},
    isReservationSaleChange: {},
    originalGetReservationResponseForReservation: {},
    originalGetReservationResponse: {},
    seatFreePassengers: {},
    seatFreePassengerCount: {},
    descriptionForChangeTransaction: {},
  }),

  mutations: {
    setSelectedGidisTrip(state, selectedGidisTrip) {
      Vue.set(state.selectedGidisTrip, sessionId, selectedGidisTrip);
    },

    setSelectedDonusTrip(state, selectedDonusTrip) {
      Vue.set(state.selectedDonusTrip, sessionId, selectedDonusTrip);
    },
    setCheckSeatSelectionPricesRequest(state, checkSeatSelectionPricesRequest) {
      Vue.set(state.checkSeatSelectionPricesRequest, sessionId, checkSeatSelectionPricesRequest);
    },
    setPrefilledSeats(state, prefilledSeats) {
      Vue.set(state.prefilledSeats, sessionId, prefilledSeats);
    },
    setTotalPrice(state, totalPrice) {
      Vue.set(state.totalPrice, sessionId, totalPrice);
    },
    setRailBookingResponse(state, railBookingResponse) {
      Vue.set(state.railBookingResponse, sessionId, railBookingResponse);
    },
    setRailBookingRequest(state, railBookingRequest) {
      Vue.set(state.railBookingRequest, sessionId, railBookingRequest);
    },
    setPassengerPriceList(state, passengerPriceList) {
      Vue.set(state.passengerPriceList, sessionId, passengerPriceList);
    },

    setCountDownActive(state, countDownActive) {
      Vue.set(state.countDownActive, sessionId, countDownActive);
    },

    setIsCountDownDisplay(state, isCountDownDisplay) {
      Vue.set(state.isCountDownDisplay, sessionId, isCountDownDisplay);
    },

    setSeferSearchInformation(state, seferSearchInformation) {
      Vue.set(state.seferSearchInformation, sessionId, seferSearchInformation);
    },

    setPassengers(state, passengers) {
      Vue.set(state.passengers, sessionId, passengers);
    },
    setPassengerWithAvailabilityRequest(state, availabilityRequest) {
      //console.log("setPassengerWithAvailabilityRequest -->");
      //console.log(availabilityRequest);
      let isACurrentTrain = false;
      if (availabilityRequest.isACurrentTrain) isACurrentTrain = availabilityRequest.isACurrentTrain;
      let fillPassenger = (requestPassCount, passengerTypeCode) => {
        for (let j = 0; j < requestPassCount; j++) {
          let passengerModel = {
            name: null,
            lastName: null,
            birthDate: null,
            email: null,
            identityNumber: null,
            passportNumber: null,
            countryId: 1,
            contact: false,
            phoneInformation: {
              countryCode: "",
              phoneNumber: "",
              isValid: true,
              props: {
                preferredCountries: ["TR"],
              },
              phoneNumberCountryObject: {
                name: "Turkey (Türkiye)",
                iso2: "TR",
                dialCode: "90",
              },
              telInputOptions: {
                autocomplete: "new-tel",
                autofocus: false,
                "aria-describedby": "telephone-input",
                maxlength: 13,
                name: "telephone",
                tabindex: 0,
                type: "tel",
                placeholder: null,
              },
            },

            isPassengerPassive: false,
            phoneCountryCode: 90,
            phoneAreaCode: 0,
            loyaltyNumber: "",
            gender: null,
            phoneNumber: null,
            gdpr: false,
            communicationCustomer: !isACurrentTrain && j === 0,
            passengerIndex: state.passengers[sessionId].length,
            passengerValidation: { saveClicked: false, validation: false, isPassengerStatusPassive: false },
            //TODO SORULACAK passengerTypeCode : availabilityRequest.passengerTypeCounts[i].passengerType.code,
            passengerTypeCode,
            seatNumber: null,
            passengerMultiLegSeatSelections: [],
            selectedSpecialServices: [],
            specialServices: [],
            filteredSpecialServices: [],
            filteredSpecialServicesCategory: [],
            isACustomer: false,
            isPackageUsed: false,
            packageUseDisabled: false,
            isPermiUsed: false,
            permiUseDisabled: false,
            blacklisted: false,
            blacklistPenalties: [],
            tariffCardNumber: null,
            eligiblePassengerTypes: [],
            userId: null,
            notificationLanguage: "TR",
          };

          state.passengers[sessionId].push(passengerModel);
          state.srmPassengers[sessionId].push(null);
        }
      };

      for (let i = 0; i < availabilityRequest.passengerTypeCounts.length; i++) {
        let diffPassengerCount = Math.abs(availabilityRequest.passengerTypeCounts[i].count - state.passengers[sessionId].length);

        if (availabilityRequest.passengerTypeCounts[i].count > state.passengers[sessionId].length) {
          fillPassenger(diffPassengerCount, availabilityRequest.passengerTypeCounts[i].id);
        } else if (availabilityRequest.passengerTypeCounts[i].count < state.passengers[sessionId].length) {
          for (let i = 0; i < diffPassengerCount; i++) {
            state.passengers[sessionId].pop();
            state.srmPassengers[sessionId].pop();
          }
        } else if (state.passengers.length === 0) {
          state.passengers[sessionId] = [];
          state.srmPassengers[sessionId] = [];
          fillPassenger(availabilityRequest.passengerTypeCounts[i].count, availabilityRequest.passengerTypeCounts[i].id);
        }
      }
    },

    setAllocationId(state, allocationId) {
      Vue.set(state.allocationId, sessionId, allocationId);
    },

    setReservationStatus(state, reservationStatus) {
      Vue.set(state.reservationStatus, sessionId, reservationStatus);
    },

    setIssueTicketResponse(state, issueTicketResponse) {
      Vue.set(state.issueTicketResponse, sessionId, issueTicketResponse);
    },
    setGetReservationResponse(state, getReservationResponse) {
      Vue.set(state.getReservationResponse, sessionId, getReservationResponse);
    },
    setUnlabeledCarTrainSearchMode(state, unlabeledCarTrainSearchMode) {
      Vue.set(state.unlabeledCarTrainSearchMode, sessionId, unlabeledCarTrainSearchMode);
    },
    setIsPaymentDone(state, isPaymentDone) {
      Vue.set(state.isPaymentDone, sessionId, isPaymentDone);
    },
    setChangeReservationRequest(state, changeReservationRequest) {
      Vue.set(state.changeReservationRequest, sessionId, changeReservationRequest);
    },
    setChangeReservationResponse(state, changeReservationResponse) {
      Vue.set(state.changeReservationResponse, sessionId, changeReservationResponse);
    },
    setChangeReservationPerformResponse(state, changeReservationPerformResponse) {
      Vue.set(state.changeReservationPerformResponse, sessionId, changeReservationPerformResponse);
    },
    setTicketChangePerformResponse(state, ticketChangePerformResponse) {
      Vue.set(state.ticketChangePerformResponse, sessionId, ticketChangePerformResponse);
    },
    setEndDate(state, endDate) {
      Vue.set(state.endDate, sessionId, endDate);
    },
    setEndDate2(state, endDate2) {
      Vue.set(state.endDate, sessionId, endDate2);
    },
    setTicketChangeType(state, ticketChangeType) {
      Vue.set(state.ticketChangeType, sessionId, ticketChangeType);
    },
    setReservationSearchStatus(state, reservationSearchStatus) {
      Vue.set(state.reservationSearchStatus, sessionId, reservationSearchStatus);
    },
    setSearchModalRequest(state, searchModalRequest) {
      Vue.set(state.searchModalRequest, sessionId, searchModalRequest);
    },
    setOriginalGetReservationResponse(state, originalGetReservationResponse) {
      Vue.set(state.originalGetReservationResponse, sessionId, originalGetReservationResponse);
    },
    setIsReservationSale(state, isReservationSale) {
      Vue.set(state.isReservationSale, sessionId, isReservationSale);
    },
    setIsReservationSaleChange(state, isReservationSaleChange) {
      Vue.set(state.isReservationSaleChange, sessionId, isReservationSaleChange);
    },
    setOriginalGetReservationResponseForReservation(state, originalGetReservationResponseForReservation) {
      Vue.set(state.originalGetReservationResponseForReservation, sessionId, originalGetReservationResponseForReservation);
    },
    setDefaultGiseModule(state) {
      if (sessionId) {
        Vue.set(state.passengers, sessionId, []);
        Vue.set(state.srmPassengers, sessionId, []);
        Vue.set(state.allocationId, sessionId, null);
        Vue.set(state.checkSeatSelectionPricesRequest, sessionId, null);
        Vue.set(state.totalPrice, sessionId, null);
        Vue.set(state.passengerPriceList, sessionId, []);
        Vue.set(state.railBookingResponse, sessionId, null);
        Vue.set(state.railBookingRequest, sessionId, null);
        Vue.set(state.reservationStatus, sessionId, null);
        Vue.set(state.issueTicketResponse, sessionId, null);
        Vue.set(state.prefilledSeats, sessionId, []);
        Vue.set(state.getReservationResponse, sessionId, null);
        Vue.set(state.isCountDownDisplay, sessionId, false);
        Vue.set(state.countDownActive, sessionId, false);
        Vue.set(state.unlabeledCarTrainSearchMode, sessionId, null);
        Vue.set(state.isPaymentDone, sessionId, null);
        Vue.set(state.changeReservationRequest, sessionId, null);
        Vue.set(state.changeReservationResponse, sessionId, { previousState: {}, currentState: {}, balance: null });
        Vue.set(state.changeReservationPerformResponse, sessionId, {
          previousState: {},
          currentState: {},
          balance: null,
        });
        Vue.set(state.ticketChangePerformResponse, sessionId, []);
        Vue.set(state.seferSearchInformation, sessionId, {});
        Vue.set(state.selectedGidisTrip, sessionId, {});
        Vue.set(state.selectedDonusTrip, sessionId, {});
        Vue.set(state.endDate, sessionId, null);
        Vue.set(state.endDate2, sessionId, null);
        Vue.set(state.ticketChangeType, sessionId, "STD");
        Vue.set(state.seferSearchInformation, sessionId, {});
        Vue.set(state.reservationSearchStatus, sessionId, false);
        Vue.set(state.searchModalRequest, sessionId, {});
        Vue.set(state.isTimeExpired, sessionId, false);
        Vue.set(state.isReservationSale, sessionId, false);
        Vue.set(state.isReservationSaleChange, sessionId, false);
        Vue.set(state.originalGetReservationResponseForReservation, sessionId, null);
        Vue.set(state.originalGetReservationResponse, sessionId, null);
        Vue.set(state.seatFreePassengers, sessionId, []);
        Vue.set(state.seatFreePassengerCount, sessionId, 0);
        Vue.set(state.descriptionForChangeTransaction, sessionId, null);
      } else {
        console.log("setDefaultGiseModule sessionId yok");
      }
    },
    setIsTimeExpired(state, isTimeExpired) {
      Vue.set(state.isTimeExpired, sessionId, isTimeExpired);
    },
    resetGiseModule(state) {
      Vue.set(state, "passengers", {});
      Vue.set(state, "srmPassengers", {});
      Vue.set(state, "allocationId", {});
      Vue.set(state, "checkSeatSelectionPricesRequest", {});
      Vue.set(state, "totalPrice", {});
      Vue.set(state, "passengerPriceList", {});
      Vue.set(state, "railBookingResponse", {});
      Vue.set(state, "railBookingRequest", {});
      Vue.set(state, "reservationStatus", {});
      Vue.set(state, "issueTicketResponse", {});
      Vue.set(state, "prefilledSeats", {});
      Vue.set(state, "getReservationResponse", {});
      Vue.set(state, "isCountDownDisplay", {});
      Vue.set(state, "countDownActive", {});
      Vue.set(state, "unlabeledCarTrainSearchMode", {});
      Vue.set(state, "isPaymentDone", {});
      Vue.set(state, "changeReservationRequest", {});
      Vue.set(state, "changeReservationResponse", {});
      Vue.set(state, "changeReservationPerformResponse", {});
      Vue.set(state, "ticketChangePerformResponse", {});
      Vue.set(state, "seferSearchInformation", {});
      Vue.set(state, "selectedGidisTrip", {});
      Vue.set(state, "selectedDonusTrip", {});
      Vue.set(state, "endDate", {});
      Vue.set(state, "endDate2", {});
      Vue.set(state, "ticketChangeType", {});
      Vue.set(state, "reservationSearchStatus", {});
      Vue.set(state, "searchModalRequest", {});
      Vue.set(state, "isTimeExpired", {});
      Vue.set(state, "isReservationSale", {});
      Vue.set(state, "isReservationSaleChange", {});
      Vue.set(state, "originalGetReservationResponseForReservation", {});
      Vue.set(state, "originalGetReservationResponse", {});
      Vue.set(state, "seatFreePassengerCount", {});
      Vue.set(state, "descriptionForChangeTransaction", {});
    },
    setSrmPassengers(state, srmPassengers) {
      Vue.set(state.srmPassengers, sessionId, srmPassengers);
    },
    setSeatFreePassengers(state, seatFreePassengers) {
      Vue.set(state.seatFreePassengers, sessionId, seatFreePassengers);
    },
    setSeatFreePassengerCount(state, seatFreePassengerCount) {
      Vue.set(state.seatFreePassengerCount, sessionId, seatFreePassengerCount);
    },
    setDescriptionForChangeTransaction(state, descriptionForChangeTransaction) {
      Vue.set(state.descriptionForChangeTransaction, sessionId, descriptionForChangeTransaction);
    },
  },

  actions: {
    //TODO: load, update, create

    loadTrainList: (context, request) => {
      return axios
        .post(context.getters.getTmsServiceUrl + "/train/train-availability", request, {
          headers: { Authorization: localStorage.getItem("AUTH_TOKEN"), "unit-id": 25 },
        })
        .then((response) => {
          return response.data;
        });
    },
    loadTrainNumbers: (context, request) => {
      let envUrl = "schedules";

      return axios
        .get(context.getters.getTmsServiceUrl + "/" + envUrl + "/load-train-numbers")
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },

    issueTicket: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/rail-booking/issue-ticket", request)
        .then((response) => {
          //TODO:Eğer başarılıysa
          context.commit("setIssueTicketResponse", response.data);
          context.commit("setReservationStatus", "BK");
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    getReservation: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/rail-booking/get-reservation", request)
        .then((response) => {
          //TODO:Eğer başarılıysa
          if (response.status === 200) {
            context.commit("setGetReservationResponse", response.data);
          }
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    makeReservation: (context, request) => {
      return axios.post(context.getters.getCrsServiceUrl + "/rail-booking/", request).then((response) => {
        //TODO:Eğer başarılıysa
        context.commit("setReservationStatus", "RESERVATION");
        return response.data;
      });
    },
    checkPermi: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/permi/check", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    quickFillTrain: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/train-filler/quick-fill-train", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
  },
  getters: {
    getPassengers: (state) => {
      return state.passengers[sessionId];
    },
    getAllocationId: (state) => {
      return state.allocationId[sessionId];
    },
    getCheckSeatSelectionPricesRequest: (state) => {
      return state.checkSeatSelectionPricesRequest[sessionId];
    },
    getCountDownActive: (state) => {
      return state.countDownActive[sessionId];
    },
    getPrefilledSeats: (state) => {
      return state.prefilledSeats[sessionId];
    },
    getTotalPrice: (state) => {
      return state.totalPrice[sessionId];
    },
    getIsCountDownDisplay: (state) => {
      return state.isCountDownDisplay[sessionId];
    },
    getPassengerPriceList: (state) => {
      return state.passengerPriceList[sessionId];
    },
    getRailBookingResponse: (state) => {
      return state.railBookingResponse[sessionId];
    },
    getRailBookingRequest: (state) => {
      return state.railBookingRequest[sessionId];
    },
    getReservationStatus: (state) => {
      return state.reservationStatus[sessionId];
    },
    getIssueTicketResponse: (state) => {
      return state.issueTicketResponse[sessionId];
    },
    getGetReservationResponse: (state) => {
      return state.getReservationResponse[sessionId];
    },
    getUnlabeledCarTrainSearchMode: (state) => {
      return state.unlabeledCarTrainSearchMode[sessionId];
    },
    getIsPaymentDone: (state) => {
      return state.isPaymentDone[sessionId];
    },
    getChangeReservationRequest: (state) => {
      return state.changeReservationRequest[sessionId];
    },
    getChangeReservationResponse: (state) => {
      return state.changeReservationResponse[sessionId];
    },
    getChangeReservationPerformResponse: (state) => {
      return state.changeReservationPerformResponse[sessionId];
    },
    getTicketChangePerformResponse: (state) => {
      return state.ticketChangePerformResponse[sessionId];
    },
    getSelectedGidisTrip: (state) => {
      return state.selectedGidisTrip[sessionId];
    },
    getSelectedDonusTrip: (state) => {
      return state.selectedDonusTrip[sessionId];
    },
    getSeferSearchInformation: (state) => {
      return state.seferSearchInformation[sessionId];
    },
    getEndDate: (state) => {
      return state.endDate[sessionId];
    },
    getEndDate2: (state) => {
      return state.endDate2[sessionId];
    },
    getTicketChangeType: (state) => {
      return state.ticketChangeType[sessionId];
    },
    getReservationSearchStatus: (state) => {
      return state.reservationSearchStatus[sessionId];
    },
    getSearchModalRequest: (state) => {
      return state.searchModalRequest[sessionId];
    },
    getIsTimeExpired: (state) => {
      return state.isTimeExpired[sessionId];
    },
    getSrmPassengers: (state) => {
      return state.srmPassengers[sessionId];
    },
    getOriginalGetReservationResponse: (state) => {
      return state.originalGetReservationResponse;
    },
    getIsReservationSale: (state) => {
      return state.isReservationSale[sessionId];
    },
    getIsReservationSaleChange: (state) => {
      return state.isReservationSaleChange[sessionId];
    },
    getOriginalGetReservationResponseForReservation: (state) => {
      return state.originalGetReservationResponseForReservation[sessionId];
    },
    getGetReservationReservationResponse: (state) => {
      return state.getReservationResponse[sessionId];
    },
    getSeatFreePassengers: (state) => {
      return state.seatFreePassengers[sessionId];
    },
    getSeatFreePassengerCount: (state) => {
      return state.seatFreePassengerCount[sessionId];
    },
    getDescriptionForChangeTransaction: (state) => {
      return state.descriptionForChangeTransaction[sessionId];
    },
  },
};
